export default {
  bindings: {
    metadata: '<'
  },
  controller: [
    function() {
      this.labelForKey = {
        account: 'Account',
        licenses: 'Licenses',
        graph: 'Graph',
        analytics: 'Activations'
      }
      this.orderedKeys = ['account', 'licenses', 'graph', 'analytics']
    }
  ],
  template: `
    <table class="cache-metadata-table table">
      <thead><tr>
        <th></th>
        <th>Last updated</th>
      </tr></thead>
      <tbody>
        <tr ng-repeat="key in $ctrl.orderedKeys">
          <th>{{$ctrl.labelForKey[key]}}</th>
          <td>
            {{ $ctrl.metadata[key].updated | timeAgo }}
            <br><small class="text-muted">{{$ctrl.metadata[key].updated | dateTimestampSeconds}}</small>
          </td>
        </tr>
      </tbody>
    </table>`
}
